import { VisualContentModalUi } from 'generated/graphql';

export const initialState: VisualContentModalUi = {
	open: false,
	visualContent: null
};
